<template>
  <div id="paypal-error" class="container">
    <h3>Esecuzione pagamento paypal</h3>

    <div id="paypal-desc" class="col-xs-12">
      Ci sono stati dei problemi durante la fase di pagamento
    </div>

    <div class="go-gome">
      <input class="btn btn-md btn-stroke button-blu-effect right go-back button-new-style"
             type="submit" value="Torna al carrello" v-on:click="goHome()">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PaypalResultErr',
    mounted: function () {
      this.$router.replace({query: null})
    },
    methods: {
      goHome: function () {
        this.$router.push({name: 'e3d'})
      }
    }
  }
</script>

<style lang="less">
  #paypal-error {
    color: #424242;
    font-size: 14px;
    font-family: "Open Sans", sans-serif;
    height: 300px;

    #paypal-desc {
      margin-top: 20px;
      padding: 0;
    }

    .button-new-style {
      background-color: #4285F4;
      border-radius: 15px;
      color: white;
      font-weight: bold;
      width: 200px;
      padding: 0;

      &:hover {
        background-color: #004B96;
        border: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PaypalResultErr.vue